// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__irDVB","empty":"ModalGraph_empty__M16c_"};